// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3LAnY","loaderOuter":"PageOverlayLoader_loaderOuter__2lqs0"};